export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            关于本站
          </h2>
          <p className="mt-2 text-sm text-foreground-500">了解51吃瓜黑料网的故事与使命</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 border border-background-200/60 rounded-lg p-6 md:p-8">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              51吃瓜黑料网成立于2020年，是国内领先的娱乐八卦与热点爆料聚合平台。我们致力于为用户提供最及时、最全面、最有深度的吃瓜内容。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              平台覆盖<strong className="text-foreground-900">明星动态、网红黑料、综艺内幕、影视揭秘、音乐争议</strong>等多个领域，拥有一支经验丰富的编辑团队和广泛的爆料线索网络。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              我们坚持<strong className="text-foreground-900">多重验证、交叉核实</strong>的内容原则，每条爆料均标注信息来源与可信度等级，让用户在享受吃瓜乐趣的同时，也能获得真实可靠的信息。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              无论是<strong className="text-foreground-900">51吃瓜黑料在线</strong>还是<strong className="text-foreground-900">51吃瓜黑料入口一二三</strong>，我们都确保用户能随时随地、稳定快捷地访问本站。吃瓜黑料入口每日更新，51黑料网吃瓜网地址永不迷路。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}